export const expenses_details = [
  {
    key:"1",
    Expense_Name: "Online Course",
    Date: "14 Jan 2024",
    Payment_Method: "Cash",
    Amount: "$3000",
  },
  {
    key:"2",
    Expense_Name: "Employee Benefits",
    Date: "21 Jan 2024",
    Payment_Method: "Cash",
    Amount: "$2500",
  },
  {
    key:"3",
    Expense_Name: "Travel",
    Date: "20 Feb 2024",
    Payment_Method: "Cheque",
    Amount: "$2800",
  },
  {
    key:"4",
    Expense_Name: "Office Supplies",
    Date: "15 Mar 2024",
    Payment_Method: "Cash",
    Amount: "$3300",
  },
  {
    key:"5",
    Expense_Name: "Welcome Kit",
    Date: "12 Apr 2024",
    Payment_Method: "Cheque",
    Amount: "$3600",
  },
  {
    key:"6",
    Expense_Name: "Equipment",
    Date: "20 May 2024",
    Payment_Method: "Cheque",
    Amount: "$2000",
  },
  {
    key:"7",
    Expense_Name: "Miscellaneous",
    Date: "06 Jul 2024",
    Payment_Method: "Cash",
    Amount: "$3400",
  },
  {
    key:"8",
    Expense_Name: "Payroll",
    Date: "02 Sep 2024",
    Payment_Method: "Cheque",
    Amount: "$4000",
  },
  {
    key:"9",
    Expense_Name: "Cafeteria",
    Date: "15 Nov 2024",
    Payment_Method: "Cash",
    Amount: "$4500",
  },
  {
    key:"10",
    Expense_Name: "Cleaning Supplies",
    Date: "10 Dec 2024",
    Payment_Method: "Cheque",
    Amount: "$3800",
  },
];
